module.exports = __webpack_public_path__ + "static/media/utilisateurs.68c4040a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/utilisateurs.svg
// module id = 216
// module chunks = 0